<template>
  <div class="table-container" v-if="canVerb(resource, 'index')">
    <actions-toolbar>
      <template #filters>
        <div class="status-filter">
          <!-- <p style="display: flex; align-items: center; gap: 5px">
            <span style="font-size: 14px; font-weight: 500">Filtri</span
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 1024 1024"
              width="18"
            >
              <path
                d="M960 682.7H527.3c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h134c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112s127.6-47.8 144-112c2.4-9.4 10.9-16 20.7-16h432.7c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3zm-597.3 128c-58.9 0-106.6-47.8-106.6-106.7s47.7-106.6 106.6-106.6 106.6 47.8 106.6 106.7-47.7 106.6-106.6 106.6zm298.6-341.4c69.4 0 127.6-47.8 144-112 2.4-9.4 10.9-16 20.7-16h134c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3H826c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h432.7c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112h0zm0-256c58.9 0 106.7 47.8 106.7 106.7s-47.8 106.7-106.7 106.7S554.6 378.9 554.6 320s47.8-106.7 106.7-106.7h0z"
              ></path>
            </svg>
          </p> -->
          <!-- <pre>{{ activeFilters }}</pre> -->
          <!-- v-for="(value, name, index) in computeActiveFilters" -->
          <div class="pill-wrapper my-3">
            <span
              class="pill"
              v-for="(value, name, index) in activeFilters"
              :key="index"
              data-color="white"
            >
              <span v-b-toggle.sidebar-1 :data-filter="name"
                ><strong>{{ sidebarFilterName(name, context) }}</strong
                >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
              >
              <span tabindex="0">
                <span
                  @click="resetSingleSidebarFilter(name)"
                  title="Rimuovi filtro"
                  >×</span
                >
              </span>
            </span>
            <template v-if="countActiveFilters">
              <span
                class="pill"
                data-color="alert"
                @click="resetAllFilters()"
                title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
              >
                <span
                  ><strong>Reset ({{ countActiveFilters }})</strong></span
                >
                <span><span>×</span></span>
              </span>
            </template>
          </div>
        </div>
      </template>
      <b-button-group
        v-b-toggle.sidebar-1
        :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
          countActiveFilters ? ' active' : ''
        }`"
        :title="getDefaultFilterMessage()"
      >
        <base-icon name="filters" width="23" height="23" />
        <span style="font-size: 14px; font-weight: 500">{{
          computedFilterTitle
        }}</span>
      </b-button-group>
      <b-button
        id="popover-create"
        class="btn-create btn--smaller"
        type="button"
        variant="primary"
        size="sm"
        @click="onAdd"
        title="Crea"
        v-if="canVerb(resource, 'store')"
      >
        <base-icon name="circled_plus" width="22" height="22" />
        Crea
      </b-button>
    </actions-toolbar>
    <div class="table-container">
      <b-sidebar
        id="sidebar-1"
        :title="computedFilterTitle"
        :backdrop="true"
        width="50dvw"
        shadow
        right
        :visible="open_filter"
        :data-open="open_filter"
        @change="onSidebarFilterChange"
      >
        <template #header="{ hide }">
          <div class="inner-header">
            <div class="inner-header--create">
              <strong class="mr-auto"> Crea un nuovo campo aggiuntivo </strong>
              <b-button
                class="btn btn--create btn--smaller"
                type="button"
                variant="primary"
                size="sm"
                @click="onAdd"
                title="Crea un nuovo campo aggiuntivo"
                :disabled="!canVerb(resource, 'store')"
              >
                <base-icon name="circled_plus" width="16" height="16" />
                <span>Crea</span>
              </b-button>
            </div>
            <div class="inner-header--info">
              <strong class="mr-auto">
                {{ computedFilterTitle }}
              </strong>
              <button class="close text-dark" @click="hide">
                <b-icon icon="x"></b-icon>
              </button>
            </div>
          </div>
        </template>
        <b-form @submit.prevent="onSearch(filterName)">
          <div class="filter">
            <div class="filter-item">
              <base-input
                name="title"
                type="text"
                label="Nome  Campo"
                v-model="filter.byAttribute.title"
                placeholder="Inserisci un nome campo"
              />
            </div>
          </div>
          <div class="actions-filter-sidebar-wrapper">
            <b-button
              type="submit"
              variant="lisaweb"
              size="sm"
              v-b-toggle:sidebar-1
              >Cerca
            </b-button>
            <b-button
              class="btn--transparent btn-reset"
              type="button"
              size="sm"
              @click="onClearFilter(filterName)"
              >Reset
            </b-button>
          </div>
        </b-form>
      </b-sidebar>
      <custom-attributes-table
        @edit="onEdit"
        @manualFetch="manualFetch"
        :fields="fields"
        :repository="repository"
        :resource="resource"
        :filterName="filterName"
        :performedSearch="computePerformedSearch"
        :filterCount="countActiveFilters"
        @destroy="onDestroy"
        @hide="onHide"
        @restore="onRestore"
        :ref="tableRef"
        :onlyActions="['edit', 'destroy']"
      ></custom-attributes-table>
    </div>
  </div>
  <div v-else class="mt-3">
    <b-icon icon="info-circle" scale="1.00"></b-icon>
    Non hai i permessi
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import CustomAttributesTable from "@/components/tables/CustomAttributes.vue";
import BaseInput from "@/components/form/BaseInput";
import { mapActions } from "vuex";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";
import BaseIcon from "@/components/BaseIcon";

export default {
  mixins: [CustomFiltersMixin, SidebarFilterMixin],
  data() {
    return {
      repository: "custom_attribute",
      resource: "attributes",
      context: "profile_custom_attributes",
      tableRef: "CustomAttributesTableRef",
      filterName: "filterCustomAttributes",
      activeFilters: {},
      performedSearch: false,
      filter: this.initFilter(),
      fields: [
        {
          key: "is_hidden",
          label: this.getDictionary("is_hidden", "attribute"),
        },
        {
          key: "title",
          label: this.getDictionary("text", "attribute"),
        },
        {
          key: "is_searchable.text",
          label: this.getDictionary("is_searchable", "attribute"),
        },
        {
          key: "is_sortable.text",
          label: this.getDictionary("is_sortable", "attribute"),
        },
        {
          key: "data_type.title",
          label: this.getDictionary("type", "attribute"),
        },
        {
          key: "entity",
          label: this.getDictionary("section", "attribute"),
          formatter: (value) => this.formatEntity(value),
        },
        // {
        //   key: "rowSelector2",
        //   label: "Ripristina",
        //   sortable: false,
        //   thStyle: {
        //     width: "70px",
        //   },
        // },
      ],
    };
  },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
  },
  components: {
    BaseIcon,
    CustomAttributesTable,
    BaseInput,
  },
  methods: {
    initFilter() {
      let init = {
        byAttribute: {
          title: null,
        },
      };
      return init;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }
      return this.activeFilters;
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(id) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: { id: `${id}` },
      });
    },
    onAdd() {
      this.$router.push({ name: `${this.resource}.create` });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          this.$store.dispatch("auth/attributes");
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Campo Aggiuntivo eliminato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onHide(id) {
      const Repo = RepositoryFactory.get(this.repository);
      let item = this.$refs[this.tableRef].items.find((e) => e.id === id);
      let payload = {
        title: item.title,
        entity: item.entity,
        section: item.section,
        data_type_id: item.data_type_id,
        is_searchable: item.is_searchable.value,
        is_sortable: item.is_sortable.value,
        is_hidden: "Y", // fix softdelete
      };
      Repo.update(id, payload)
        // Repo.restore(id)
        .then(() => {
          this.$store.dispatch("auth/attributes");
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Campo Aggiuntivo nascosto con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onRestore(id) {
      const Repo = RepositoryFactory.get(this.repository);
      let item = this.$refs[this.tableRef].items.find((e) => e.id === id);
      let payload = {
        title: item.title,
        entity: item.entity,
        section: item.section,
        data_type_id: item.data_type_id,
        is_searchable: item.is_searchable.value,
        is_sortable: item.is_sortable.value,
        is_hidden: "N", // fix softdelete
      };
      Repo.update(id, payload)
        // Repo.restore(id)
        .then(() => {
          this.$store.dispatch("auth/attributes");
          this.$refs[this.tableRef].fetch();
          this.$showSnackbar({
            preset: "success",
            text: "Campo Aggiuntivo ripristinato con successo",
          });
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetFilter();
      this.resetPagination();
      this.removeFilterByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      this.$refs[this.tableRef].sortBy = "";
      this.$refs[this.tableRef].sortDesc = false;
    },
    formatEntity(value) {
      const splitted_string = value.split("\\");
      if (splitted_string.length === 3) {
        switch (splitted_string[2]) {
          case "Registry":
            return "Clienti";
          case "Claim":
            return "Sinistri";
          case "InsurancePolicy":
            return "Polizze";
        }
      }
      return "";
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
  },
  mounted() {
    this.$refs[this.tableRef].fetch();
  },
};
</script>
